import * as React from 'react';

import { registerViewTransitionEpic } from './router.epic';
import { IGenericFunction } from 'types/generics';
import { IViewTransitions, TargetStateCondition } from 'types/router';

interface IRouteState {}

export interface IRouteProps {
    readonly is: string;
    readonly render: JSX.Element;
    readonly transitions?: IViewTransitions;
    readonly activeView: string;
}

class Route extends React.Component<IRouteProps, IRouteState> {
    private readonly unregisterEpicsCallback: () => void;

    constructor(props: IRouteProps) {
        super(props);
        this.unregisterEpicsCallback = this.registerEpics(props);
    }

    public registerEpics({ transitions, is: currentState }: IRouteProps) {
        const unregisterLinks: IGenericFunction<void>[] = [];

        if (transitions) {
            Object.keys(transitions).forEach(targetAction => {
                const transitionStates = transitions[targetAction];

                Object.keys(transitionStates).forEach(targetState => {
                    const optionalFilterValue: TargetStateCondition = transitionStates[targetState];

                    const unregisterEpicCallback = registerViewTransitionEpic({
                        targetAction,
                        targetState,
                        currentState,
                        optionalFilterValue
                    });

                    unregisterLinks.push(unregisterEpicCallback);
                });
            });
        }

        return () => {
            unregisterLinks.forEach(unregisterEpicInstanceCallback => {
                unregisterEpicInstanceCallback();
            });
        };
    }

    public componentWillUnmount() {
        this.unregisterEpicsCallback();
    }

    public render() {
        const { activeView, is: currentState, render } = this.props;

        if (currentState !== activeView) {
            return null;
        }
        return render;
    }
}

export default Route;
